/**
 * Hero
 */

export default function () {
  const popupTriggers = document.querySelectorAll("[data-open-popup]");
  if (!popupTriggers.length) {
    return;
  }


  popupTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();

      // Get the target popup ID from the link
      const targetId = trigger.getAttribute("aria-controls");
      if (!targetId) return;

      // Find the toggle button for that specific popup
      const popupToggle = document.querySelector(
        `.c-popup__toggle[aria-controls="${targetId}"]`
      );

      if (popupToggle) {
        popupToggle.click(); // open the matched popup
      }
    });
  });
}
